/** @jsx jsx */
import { type SerializedStyles, css, jsx } from '@emotion/react';

import type { ReactNode } from 'react';

import { Link, Typography2 } from '@coursera/cds-core';

const styles = {
  root: css`
    gap: var(--cds-spacing-200);
    display: flex;
    align-items: end;
    margin-bottom: var(--cds-spacing-150);
  `,
};

type Props = {
  showPageTitleHeadingSize?: boolean;
  additionalStyles?: SerializedStyles;
  ctaTitle?: string;
  ctaUrl?: string;
  children: ReactNode;
};

const SectionHeadingComponent = (props: Props) => {
  const { children, additionalStyles, showPageTitleHeadingSize = false, ctaTitle, ctaUrl } = props;
  return (
    <div css={[styles.root, additionalStyles]}>
      <Typography2
        component={showPageTitleHeadingSize ? 'h1' : 'h2'}
        variant={showPageTitleHeadingSize ? 'titleMedium' : 'subtitleLarge'}
      >
        {children}
      </Typography2>
      {ctaTitle && ctaUrl && (
        <Link variant="quiet" typographyVariant="subtitleMedium" href={ctaUrl}>
          {ctaTitle}
        </Link>
      )}
    </div>
  );
};

export default SectionHeadingComponent;
